import React, { CSSProperties, ReactNode, useState } from 'react';
import styled from 'styled-components';

import MovingFocusInput from './MovingFocusInput';
import { FontStyle } from '@/utils/StyleUtil';

interface IForm {
    label?: string | ReactNode;
    labelStyle?: CSSProperties;
    hasTitle?: boolean;
    title?: string;
    titlePlaceHolder?: string;
    titleMaxLength?: number;
    onTitleChange?: Function;
    content: string;
    contentPlaceHolder: string;
    contentMaxLength: number;
    onContentChange: Function;
    isMoving?: boolean;
    suffix?: ReactNode;
    className?: string;
    onFocus?: Function;
    style?: CSSProperties;
}

const TitleNContentForm = ({
    label,
    labelStyle,
    hasTitle,
    titlePlaceHolder,
    title,
    titleMaxLength,
    onTitleChange,
    contentPlaceHolder,
    content,
    contentMaxLength,
    onContentChange,
    isMoving,
    suffix,
    className,
    onFocus,
    style,
}: IForm) => {
    const [contentLength, setContentLength] = useState(content.length);
    const [isFocusOnTitle, setIsFocusOnTitle] = useState(false);
    const [isFocusOnContent, setIsFocusOnContent] = useState(false);

    return (
        <FormContainer className={className}>
            <div style={labelStyle}>{label}</div>
            {hasTitle && (
                <TitleInput
                    placeholder={titlePlaceHolder}
                    value={title}
                    maxLength={titleMaxLength}
                    onChange={e => onTitleChange!(e.target.value)}
                    onFocus={() => setIsFocusOnTitle(true)}
                    onBlur={() => setIsFocusOnTitle(false)}
                    isFocus={isFocusOnTitle}
                />
            )}
            <ContentInput
                style={style}
                tag="textarea"
                placeholder={contentPlaceHolder}
                value={content}
                maxLength={contentMaxLength}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    if (e.target.value.length <= contentMaxLength) {
                        onContentChange(e.target.value);

                        setContentLength(e.target.value.length);
                    }
                }}
                onFocus={() => {
                    setIsFocusOnContent(true);
                    if (onFocus) onFocus();
                }}
                onBlur={() => setIsFocusOnContent(false)}
                isFocus={isFocusOnContent}
                isMoving={isMoving}
            />
            {suffix ? (
                suffix
            ) : (
                <ContentLength>
                    {contentLength}/{contentMaxLength}
                </ContentLength>
            )}
        </FormContainer>
    );
};

const FormContainer = styled.div`
    ${({ theme }) => theme.flex.flexColumn}
`;

const TitleInput = styled.input<{ isFocus: boolean }>`
    overflow-x: hidden;
    scrollbar-width: none;
    min-width: calc(100% * 16 / 14);
    height: calc(50px * 16 / 14);
    border: ${({ isFocus }) => (isFocus ? '1px solid #444' : '1px solid #dadada')};
    border-radius: 10px;
    background-color: #ffffff;
    ${FontStyle(16, (22 * 16) / 14, '400', '#444444', -1)};
    transform: scale(0.875);
    transform-origin: left top;
    padding: 14px 20px;
    margin-bottom: 8px;
    ::placeholder {
        color: #c8c8c8;
    }

    &:focus {
        outline: none;
        /* box-shadow: 0 0 0 1px #888888; */
    }
`;

const ContentInput = styled(MovingFocusInput)<{ isFocus: boolean }>`
    overflow-x: hidden;
    scrollbar-width: none;
    width: calc(100% * 16 / 14);
    height: calc(220px * 16 / 14);
    border: ${({ isFocus }) => (isFocus ? '1px solid #444' : '1px solid #dadada')};
    border-radius: 10px;
    outline-color: #888888;
    ${FontStyle(16, (22 * 16) / 14, '400', '#444444', -1)};
    transform: scale(0.875);
    transform-origin: left top;
    resize: none;
    background-color: #ffffff;
    padding: 20px;
    ::placeholder {
        color: #c8c8c8;
    }

    &:focus {
        outline: none;
        /* box-shadow: 0 0 0 1px #888888; */
    }
`;

const ContentLength = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    ${({ theme }) => theme.flex.justifyEnd};

    ${FontStyle(12, 20, '400', '#acacac', 0)}
    margin-top: -20px;
`;

export default TitleNContentForm;
